import { render, staticRenderFns } from "./WorkOrderInfo.vue?vue&type=template&id=1bc8b48f"
import script from "./WorkOrderInfo.vue?vue&type=script&lang=js"
export * from "./WorkOrderInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports